{
  "behaviorSummaryCard": {
    "ronLikelihood": {
      "label": "RON-Wahrscheinl.",
      "tooltip": "Wahrscheinlichkeit, dass dieses Flugzeug über Nacht bleibt"
    },
    "typicalArrival": {
      "label": "Typische Ankunft",
      "tooltip": "Häufigste Ankunftszeit für dieses Flugzeug"
    },
    "typicalTurn": {
      "label": "Typ. Abfertigung",
      "tooltip": "Durchschnittliche Bodenzeit zwischen Ankunft und Abflug",
      "tooltipDetail": "Basierend auf historischen Flugdaten"
    },
    "visitTypes": {
      "quickTurn": "Quick Turn",
      "dayStop": "Tagesstopp",
      "ron": "RON"
    },
    "basedOn": "Basierend auf",
    "title": "Verhaltensübersicht"
  },
  "filters": {
    "flightTypes": {
      "all": "Alle",
      "arrivals": "Ankünfte",
      "departures": "Abflüge"
    },
    "statuses": {
      "scheduled": "Geplant",
      "active": "Aktiv",
      "landed": "Gelandet",
      "cancelled": "Abgebrochen"
    },
    "flags": {
      "vipOnly": "Nur VIP",
      "favoritesOnly": "Nur Favoriten",
      "showIgnored": "Ignorierte zeigen"
    },
    "search": {
      "placeholder": "Flüge suchen..."
    },
    "lastUpdated": {
      "neverUpdated": "Nie aktualisiert",
      "justNow": "Gerade eben",
      "minutesAgo": "Vor Minuten",
      "secondsAgo": "Vor Sekunden"
    },
    "dropdowns": {
      "allStatus": "Alle Status",
      "flags": "Markierungen",
      "operator": "Betreiber"
    },
    "myReservations": "Meine Reservierungen",
    "liveStatus": "LIVE",
    "arrivingSoon": "Ankunft in Kürze"
  },
  "services": {
    "fuel": "Fuel",
    "hangar": "Hangar",
    "catering": "Catering",
    "hotel": "Hotel",
    "crewCar": "Crew-Auto",
    "limo": "Limo",
    "carRental": "Mietwagen",
    "arrivalLimo": "Ankunftslimousine",
    "departureLimo": "Abfahrtslimousine",
    "deicing": "Enteisung",
    "groundPower": "Bodenstrom",
    "gpu": "GPU",
    "lavatory": "Toilette",
    "lavService": "Toilettenservice",
    "water": "Wasser",
    "towing": "Schleppen",
    "oxygen": "Sauerstoff",
    "conferenceRoom": "Konferenzraum",
    "customs": "Zoll",
    "cipService": "CIP-Service",
    "payment": "Zahlung",
    "dishes": "Gerichte",
    "linens": "Wäsche",
    "otherArrival": "Sonstiges (Ankunft)",
    "otherDeparture": "Sonstiges (Abflug)"
  },
  "flightRow": {
    "tooltips": {
      "hasReservation": "Hat Reservierung"
    }
  },
  "flightNotes": {
    "defaultTags": {
      "ops": "Ops",
      "fuel": "Fuel",
      "catering": "Catering",
      "hotel": "Hotel",
      "crew": "Crew",
      "vipRequest": "VIP-Anfrage",
      "followUp": "Nachfassen",
      "urgent": "Dringend"
    },
    "search": {
      "placeholder": "Notizen suchen...",
      "clearSearch": "Suche löschen",
      "noMatches": "Keine Treffer"
    },
    "emptyState": {
      "title": "Noch keine Notizen",
      "message": "Nutze Notizen, um dich mit deinem Team über diesen Flug abzustimmen",
      "quickActions": {
        "passengersArrived": {
          "label": "Passagiere angekommen",
          "template": "Passagiere sind angekommen",
          "tag": "Ops"
        },
        "fuelCompleted": {
          "label": "Betankt",
          "template": "Tankservice abgeschlossen",
          "tag": "Fuel"
        },
        "crewCalled": {
          "label": "Crew gerufen",
          "template": "Crew wurde benachrichtigt",
          "tag": "Crew"
        },
        "ownerRequest": {
          "label": "Eigentümeranfrage",
          "template": "Eigentümer angefragt: ",
          "tag": "VIP-Anfrage"
        }
      }
    },
    "dateLabels": {
      "today": "Heute",
      "yesterday": "Gestern"
    },
    "composer": {
      "placeholder": "Notiz hinzufügen...",
      "quickTags": "Schnelltags",
      "helpText": "Drücke Enter zum Senden, Umschalt+Enter für neue Zeile"
    },
    "noteActions": {
      "edited": "bearb.",
      "cancel": "Abbrechen"
    },
    "messages": {
      "loadFailed": "Notizen laden fehlgeschlagen",
      "notePinned": "Notiz angepinnt",
      "noteUnpinned": "Notiz losgelöst",
      "updateFailed": "Aktualisierung fehlgeschlagen",
      "noteUpdated": "Notiz aktualisiert",
      "noteDeleted": "Notiz gelöscht",
      "deleteFailed": "Notiz löschen fehlgeschlagen",
      "noteCopied": "In Zwischenablage kopiert",
      "copyFailed": "Kopieren fehlgeschlagen"
    },
    "confirmations": {
      "deleteNote": "Notiz löschen? Dies kann nicht rückgängig gemacht werden."
    }
  },
  "flightList": {
    "emptyState": {
      "noFlightsFound": "Keine Flüge gefunden",
      "tryAdjustingFilters": "Passe deine Filter an"
    }
  },
  "notesDialog": {
    "labels": {
      "vip": "VIP"
    }
  },
  "opsCenterLoading": {
    "logoAlt": "AirPlx-Logo",
    "messages": {
      "fetchingOperations": "Lade Vorgänge...",
      "syncingFlightAware": "Synchronisiere mit FlightAware...",
      "loadingPositions": "Lade Positionen...",
      "updatingArrivals": "Aktualisiere Ankünfte...",
      "checkingDepartures": "Abflüge werden geprüft...",
      "pullingTracking": "Tracking-Daten werden abgerufen..."
    }
  },
  "tailDetailDrawer": {
    "overallTendencies": {
      "title": "Allgemeine Tendenzen",
      "lastDays": "Letzte Tage",
      "subtitle": "Untertitel"
    },
    "estimatedFuel": {
      "label": "Gesch. Kraftstoff",
      "tooltip": "Geschätzter Treibstoffbedarf basierend auf Flugzeugtyp und typischer Flugdistanz",
      "low": "Niedrig",
      "high": "Hoch"
    },
    "flightsPerDay": {
      "label": "Flüge/Tag",
      "tooltip": "Durchschnittliche Flugaktivität für dieses Flugzeug",
      "tooltipDetail": "Im Vergleich zu ähnlichen Flugzeugtypen",
      "busier": "Belebter",
      "quieter": "Leiser"
    },
    "medianStay": {
      "label": "Median Aufenth.",
      "tooltip": "Typische Aufenthaltsdauer dieses Flugzeugs an deinem FBO",
      "tooltipDetail": "Basierend auf früheren Besuchen",
      "shorter": "Kürzer",
      "longer": "Länger"
    },
    "ronPercentage": {
      "label": "RON %",
      "tooltip": "Anteil der Besuche mit Übernachtung",
      "tooltipDetail": "Übernachtungsanteil",
      "quick": "Schnelle Wenden",
      "overnight": "Übernachtung"
    },
    "recentFlights": {
      "noFlights": "Keine aktuellen Flüge",
      "tableHeaders": {
        "date": "Datum",
        "route": "Route",
        "times": "Zeiten",
        "stay": "Hier",
        "duration": "Dauer",
        "status": "Status"
      },
      "lastDays": "Letzte Tage",
      "title": "Letzte Flüge"
    },
    "prediction": {
      "atAirport": "Am Flughafen",
      "basedOn": "Basierend auf",
      "confidence": "Konfidenz"
    }
  },
  "tvFooter": {
    "justNow": "Gerade eben",
    "never": "Nie",
    "hoursAgo": "Vor Stunden",
    "minutesAgo": "Vor Minuten",
    "secondsAgo": "Vor Sekunden",
    "updated": "Geändert"
  },
  "tvHeader": {
    "live": "LIVE",
    "autoScroll": "Auto-Scrollen",
    "exitTVMode": "TV-Modus beenden",
    "switchToDarkMode": "Zum Dunkelmodus wechseln",
    "switchToLightMode": "Zum hellen Modus wechseln",
    "lastUpdated": "Letzte Änderung"
  },
  "tvModeButton": {
    "tooltip": "In TV-Modus öffnen",
    "dialogTitle": "TV-Modus",
    "tvModeLink": "TV-Modus-Link",
    "helperText": "Öffne diesen Link auf einem Display, um das Flight Board anzuzeigen",
    "activeFilters": "Aktive Filter",
    "noFilters": "Keine Filter aktiv",
    "filterLabels": {
      "arrivals": "Nur Ankünfte",
      "departures": "Nur Abflüge",
      "vipOnly": "Nur VIP",
      "favoritesOnly": "Nur Favoriten",
      "myReservations": "Meine Reservierungen",
      "showIgnored": "Inkl. ignorierter",
      "search": "Suchen",
      "status": "Status",
      "type": "Typ"
    },
    "buttons": {
      "copyLink": "Link kopieren",
      "copied": "Kopiert!",
      "openInNewWindow": "In neuem Fenster öffnen",
      "cancel": "Abbrechen"
    }
  },
  "alertToast": {
    "relativeTime": {
      "hoursAgo": "Vor Stunden",
      "justNow": "Gerade eben",
      "minutesAgo": "Vor Minuten",
      "oneHourAgo": "Vor einer Stunde",
      "oneMinuteAgo": "Vor einer Minute"
    },
    "unknownAircraft": "Unbekanntes Flugzeug"
  },
  "dashboard": {
    "errors": {
      "failedToLoadFlights": "Fehler: Flüge konnten nicht geladen werden"
    }
  },
  "dataCoverageIndicator": {
    "etaAvailable": "ETA verfügbar",
    "liveTracking": "Live-Tracking",
    "noETA": "Keine ETA",
    "noLiveData": "Keine Live-Daten",
    "operatorKnown": "Bekannter Betreiber",
    "unknownOperator": "Unbekannter Betreiber"
  },
  "flightDetailDrawer": {
    "altitudeStates": {
      "climbing": "Steigflug",
      "descending": "Sinkflug",
      "level": "Stufe"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "fields": {
      "actualIn": "Akt. Ankunft:",
      "actualOut": "Ist-Abflug:",
      "airport": "Flughafen:",
      "altitude": "Höhe:",
      "altitudeChange": "Höhenänderung:",
      "assignedRampSpot": "Zugewiesener Abstellplatz:",
      "atcCallsign": "ATC-Rufzeichen:",
      "code": "Code:",
      "delay": "Verzög.:",
      "estimatedIn": "Geschätzte Ankunft:",
      "estimatedOut": "Gesch. Abflugzeit:",
      "flightId": "Flug-ID:",
      "fuelRequest": "Tankantrag:",
      "groundspeed": "Geschwindigkeit:",
      "hangarRequested": "Hangar angefragt:",
      "heading": "Kurs:",
      "iata": "Iata:",
      "lastUpdated": "Letzte Änderung:",
      "makeModel": "Modell/Typ:",
      "position": "Position:",
      "progress": "Fortschritt:",
      "registration": "Registrierung:",
      "scheduledIn": "Geplante Ankunft:",
      "scheduledOut": "Geplante Abflugzeit:",
      "status": "Status:",
      "terminalGate": "Terminal-Gate:",
      "type": "Typ:"
    },
    "formats": {
      "delayMinutes": "Verspätung (Min.)",
      "gate": "Gate",
      "terminal": "Terminal"
    },
    "noFlightSelected": "Kein Flug ausgewählt",
    "placeholders": {
      "fuel": "Fuel",
      "spot": "Spot"
    },
    "sections": {
      "aircraft": "Flugzeug",
      "destination": "Ziel",
      "flightInformation": "Fluginformationen",
      "internalNotes": "Interne Notizen",
      "livePosition": "Live-Position",
      "operations": "Betrieb",
      "operator": "Betreiber",
      "origin": "Abflugort"
    },
    "units": {
      "degrees": "Grad",
      "feet": "Fuß",
      "knots": "Knoten"
    }
  },
  "opsMap": {
    "airport": {
      "code": "Code",
      "name": "Name"
    },
    "emptyState": "Keine Einträge",
    "labels": {
      "eta": "ETA",
      "etd": "Etd",
      "from": "Von"
    }
  },
  "otherServicesPopover": {
    "title": "Weitere Dienste Popover"
  }
}
